import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

const Legend = ({ scale, options = {}, className = "ColorScale" }) => {
  const {
    title = "Max Temperature (°C)",
    tickSize = 6,
    tickPadding = 3,
    tickFormat = scale.tickFormat(),
    width = 200,
    height = 20 + tickSize + tickPadding,
    marginTop = 18,
    marginRight = 0,
    marginBottom = 16 + tickSize + tickPadding,
    marginLeft = 0,
  } = options;

  const svgRef = useRef();

  useEffect(() => {
    const svg = d3.select(svgRef.current);

    let tickAdjust = (g) =>
      g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
    let x;

    // Continuous
    if (scale.ticks && scale.tickFormat) {
      const n = Math.min(5, scale.ticks().length);

      x = scale.copy().rangeRound([marginLeft, width - marginRight]);

      svg
        .append("g")
        .attr("transform", `translate(0,${height - marginBottom})`)
        .call(d3.axisBottom(x).ticks(n, tickFormat))
        .call(tickAdjust)
        .call((g) => g.select(".domain").remove())
        .call((g) =>
          g
            .append("text")
            .attr("x", marginLeft)
            .attr("y", marginTop + marginBottom - height - 6)
            .attr("fill", "#212121")
            .attr("text-anchor", "start")
            .attr("font-weight", "bold")
            .attr("font-family", "Poppins")
            .text(title)
        );
    }
  }, [scale, options, height, svgRef]);

  const colorScale = d3
    .scaleSequential()
    .domain(scale.domain())
    .interpolator(d3.interpolateTurbo);

  return (
    <svg
      ref={svgRef}
      className={className}
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      style={{
        overflow: "visible",
        display: "block",
        paddingBottom: "16px",
        paddingTop: "8px",
      }}
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          {colorScale.ticks().map((tick, i) => (
            <stop
              key={tick}
              offset={`${(i * 100) / (colorScale.ticks().length - 1)}%`}
              stopColor={colorScale(tick)}
            />
          ))}
        </linearGradient>
      </defs>
      <rect
        x={marginLeft}
        y={marginTop}
        width={width - marginLeft - marginRight}
        height={height - marginTop - marginBottom}
        fill="url(#gradient)"
      />
    </svg>
  );
};

export default Legend;
